import { render, staticRenderFns } from "./provider-notification-list-content.vue?vue&type=template&id=5b70ef5b&scoped=true&"
import script from "./provider-notification-list-content.vue?vue&type=script&lang=ts&"
export * from "./provider-notification-list-content.vue?vue&type=script&lang=ts&"
import style0 from "./provider-notification-list-content.vue?vue&type=style&index=0&id=5b70ef5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70ef5b",
  null
  
)

export default component.exports